export const ROUTE_META = {
  '/': {
    title: 'VIT GPA Calculator Platform | GradeVIT',
    description: 'Fast, distraction-free VIT GPA and CGPA calculators with grade scale conversion.',
    keywords: 'VIT GPA Calculator, VIT CGPA Calculator, VIT Grade to Percentage'
  },
  '/gpa-calculator': {
    title: 'VIT GPA Calculator | GradeVIT',
    description: 'Calculate semester GPA using VIT grade points and credit weights.',
    keywords: 'VIT GPA calculator, semester GPA VIT'
  },
  '/cgpa-calculator': {
    title: 'VIT CGPA Calculator | GradeVIT',
    description: 'Compute cumulative CGPA across semesters using weighted credits.',
    keywords: 'VIT CGPA calculator, cumulative GPA VIT'
  },
  '/grade-converter': {
    title: 'VIT Grade Scale Converter | GradeVIT',
    description: 'Convert VIT grades between 10, 4, 5 and percentage scales.',
    keywords: 'VIT grade converter, GPA to percentage VIT'
  },
  '/faq': {
    title: 'VIT GPA FAQ | GradeVIT',
    description: 'VIT-specific grading FAQs for GPA, CGPA, credits and conversion rules.',
    keywords: 'VIT grading FAQ, VIT GPA questions'
  }
};
